// components/ActionButtons.js
import React from 'react';
import styled from 'styled-components';
import { cores } from '../../../styles/styleUtils';

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: auto;
`;

const Button = styled.button`
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;

const ConfirmButton = styled(Button)`
  background-color: ${cores.laranja};
  color: white;
  border: none;

  &:hover {
    background-color: ${cores.laranjaEscuro};
  }

  // Estilo para quando o botão estiver desabilitado
  &:disabled {
    background-color: #cccccc; /* Cinza */
    color: #666666; /* Cor do texto mais escura para contraste */
    cursor: not-allowed; /* Altera o cursor para indicar que não é clicável */
  }
`;

const SaveButton = styled(Button)`
  background-color: ${cores.chumbo};
  color: white;
  border: none;

  &:hover {
    background-color: #1c1c1c;
  }

  // Estilo para quando o botão estiver desabilitado
  &:disabled {
    background-color: #cccccc; /* Cinza */
    color: #666666; /* Cor do texto mais escura para contraste */
    cursor: not-allowed; /* Altera o cursor para indicar que não é clicável */
  }
`;

const CancelButton = styled(Button)`
  background-color: #dc3545; /* Red */
  color: white;
  border: none;
  margin-right: auto;
  &:hover {
    background-color: #c82333;
  }
`;

function ActionButtonsOs({ onConfirm, onCancel, onGenerate, disableConfirm, visualiza }) {
  return (
    <ButtonContainer>
      <CancelButton onClick={onCancel}>Cancelar</CancelButton>
      <SaveButton onClick={onConfirm} disabled={disableConfirm || visualiza}>Salvar</SaveButton>
      <ConfirmButton onClick={onGenerate} disabled={disableConfirm || visualiza}>Gerar OS</ConfirmButton>
    </ButtonContainer>
  );
}

export default ActionButtonsOs;